<template>
  <div class="mt-5">
    <div class="box px-5 intro-y mb-5">
      <div class="nav-tabs flex flex-col sm:flex-row justify-center lg:justify-start">
        <router-link
          :to="{ name: 'ReportEndDay' }"
          class="py-4 sm:mr-8"
          :class="{ active: $route.name === 'ReportEndDay' }"
          >Өндөрлөөгүй</router-link
        >
        <router-link
          :to="{ name: 'ReportEndDayCompleted' }"
          class="py-4 sm:mr-8"
          :class="{ active: $route.name === 'ReportEndDayCompleted' }"
          >Өндөрлөсөн</router-link
        >
      </div>
    </div>
    <div class="intro-y">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {};
</script>
